module.exports = __webpack_public_path__ + "static/autosave-icon-cdee1532f92fdb40e0562a679c7af31a.png";